import React from 'react';
import { bool, func, string } from 'prop-types';

import styles from './Checkbox.scss';

function Checkbox({ label, checked, onChange }) {
  return (
    <label className={styles.root}>
      <input
        className={styles.input}
        type="checkbox"
        checked={checked}
        onChange={({ target: { checked } }) => onChange(checked)}
      />
      <span className={styles.checkIcon} />
      <span className={styles.label}>{label}</span>
    </label>
  );
}

Checkbox.propTypes = {
  checked: bool.isRequired,
  label: string.isRequired,
  onChange: func.isRequired,
};

Checkbox.defaultProps = {
  checked: false,
};

export default Checkbox;



// WEBPACK FOOTER //
// ./app/components/fields/Checkbox/Checkbox.jsx